import React, { useEffect, useState } from "react";
import clsx from "clsx";

import Loader from "./Loader";

import { ICONS } from "../constants";

const EditForm = ({ data, rowIndex, columns, colSpan, onSave, onCancel }) => {
  const [formData, setFormData] = useState({ ...data });
  const [isSaving, setIsSaving] = useState(false);

  const getContent = (column) => {
    let columnContent = column.key ? formData[column.key] : null;

    if (column.render) {
      columnContent = column.render(formData, rowIndex);
    }

    return columnContent;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.currentTarget;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSave = () => {
    setIsSaving(true);
    onSave(formData);
  };

  useEffect(() => {
    setFormData({ ...data });
  }, [data, rowIndex]);

  return (
    <tr className="datatable_edit">
      {colSpan > 0 && <td />}
      {columns.map((col, index) => {
        const content = getContent(col);

        return (
          <td key={index}>
            {!col.editable || isSaving ? (
              content
            ) : (
              <input
                defaultValue={content}
                name={col.key}
                onChange={handleInputChange}
              />
            )}
          </td>
        );
      })}
      <td className={clsx("datatable_actions", { loading: isSaving })}>
        {isSaving ? (
          <Loader />
        ) : (
          <>
            <span
              className="datatable_actions-save"
              onClick={handleSave}
              children={<ICONS.Check />}
            />
            <span
              className="datatable_actions-cancel"
              onClick={onCancel}
              children={<ICONS.Close />}
            />
          </>
        )}
      </td>
    </tr>
  );
};

export default EditForm;
